/**
 * Modal Module
 * Wyświetlanie okna dialogowego z backdrop (przyciemnienie strony)
 *
 * API:
 *   // Wariant domyślny (voucher)
 *   Modal.show({
 *     image: 'assets/images/vouchers/voucher-decathlon.jpg',  // opcjonalne
 *     title: 'Czy na pewno chcesz odebrać ten voucher?',
 *     text: 'Z Twojego konta zostanie pobrane:',
 *     value: '500 punktów',                                    // opcjonalne
 *     confirmLabel: 'Odbierz',                                 // obowiązkowy
 *     cancelLabel: 'Anuluj',                                   // opcjonalny
 *     onConfirm: function() { ... },
 *     onCancel: function() { ... }
 *   });
 *
 *   // Wariant punktowy
 *   Modal.show({
 *     variant: 'points',
 *     image: 'assets/images/win-card-big.jpg',
 *     pointsNumber: '235',
 *     pointsLabel: 'Punktów WIN',
 *     text: '[First name] kod został wprowadzony poprawnie!',
 *     value: '+ 15 PUNKTÓW',
 *     confirmLabel: 'Zamknij'
 *   });
 *
 *   // Wariant dynamicznego wyzwania (tytuł Camel Curved, treść wyśrodkowana)
 *   Modal.show({
 *     variant: 'challenge',
 *     image: 'assets/images/dynamiczne/challenge-friends.jpg',
 *     aiBadge: 'Wygenerowane przez AI',                       // opcjonalne — badge na grafice
 *     preheader: 'Dynamiczny bonus:',                         // opcjonalne — nadtytuł
 *     title: 'Ekstra punkty',
 *     text: '<p>...</p>',
 *     confirmLabel: 'Weź udział'
 *   });
 *
 *   // Slot postępu wyzwania (dowolny wariant, np. 'points' po dodaniu kodu)
 *   Modal.show({
 *     variant: 'points', ...,
 *     challenge: {
 *       title: 'Dynamiczny bonus: +1',
 *       current: 8, total: 20,                                // opcjonalne — bez nich brak paska
 *       counterLabel: 'dodanych kodów',
 *       message: 'Do nagrody zostało: 12'                     // opcjonalne
 *     }
 *   });
 *
 *   Modal.hide();
 */

(function () {
    'use strict';

    var currentBackdrop = null;

    /**
     * Utwórz element DOM modala
     */
    function createModalElement(options) {
        var isPoints = options.variant === 'points';
        var isChallenge = options.variant === 'challenge';

        // Backdrop
        var backdrop = document.createElement('div');
        backdrop.className = 'modal-backdrop';

        // Dialog
        var dialog = document.createElement('div');
        dialog.className = 'modal' + (isPoints ? ' modal--points' : '') + (isChallenge ? ' modal--challenge' : '');
        dialog.setAttribute('role', 'dialog');
        dialog.setAttribute('aria-modal', 'true');

        var titleId = 'modal-title-' + Date.now();
        dialog.setAttribute('aria-labelledby', titleId);

        // Close button
        var closeBtn = document.createElement('button');
        closeBtn.className = 'modal__close';
        closeBtn.setAttribute('aria-label', 'Zamknij');
        closeBtn.addEventListener('click', function () {
            hide();
        });
        dialog.appendChild(closeBtn);

        // Image (opcjonalne)
        if (options.image) {
            var imageWrapper = document.createElement('div');
            imageWrapper.className = 'modal__image';

            var img = document.createElement('img');
            img.src = options.image;
            img.alt = options.title || options.pointsLabel || '';
            img.draggable = false;
            imageWrapper.appendChild(img);

            if (options.aiBadge) {
                var aiBadge = document.createElement('span');
                aiBadge.className = 'ai-badge ai-badge--xs ai-badge--dark modal__ai-badge';
                aiBadge.textContent = options.aiBadge;
                imageWrapper.appendChild(aiBadge);
            }

            dialog.appendChild(imageWrapper);
        }

        // Body
        var body = document.createElement('div');
        body.className = 'modal__body';

        if (isPoints) {
            // === Wariant punktowy ===

            // Points number (duża liczba)
            var pointsBlock = document.createElement('div');
            pointsBlock.className = 'modal__points';

            if (options.pointsNumber) {
                var pointsNumber = document.createElement('p');
                pointsNumber.className = 'modal__points-number';
                pointsNumber.id = titleId;
                pointsNumber.textContent = options.pointsNumber;
                pointsBlock.appendChild(pointsNumber);
            }

            // Points label (PUNKTÓW WIN)
            if (options.pointsLabel) {
                var pointsLabel = document.createElement('p');
                pointsLabel.className = 'modal__points-label';
                pointsLabel.textContent = options.pointsLabel;
                pointsBlock.appendChild(pointsLabel);
            }

            body.appendChild(pointsBlock);

            // Separator
            var separator = document.createElement('div');
            separator.className = 'modal__separator';
            body.appendChild(separator);

        } else {
            // === Wariant domyślny / challenge ===

            // Preheader (nadtytuł)
            if (options.preheader) {
                var preheader = document.createElement('p');
                preheader.className = 'modal__preheader';
                preheader.textContent = options.preheader;
                body.appendChild(preheader);
            }

            // Title
            if (options.title) {
                var title = document.createElement('h2');
                title.className = 'modal__title';
                title.id = titleId;
                title.textContent = options.title;
                body.appendChild(title);
            }

            // Separator
            var separator2 = document.createElement('div');
            separator2.className = 'modal__separator';
            body.appendChild(separator2);
        }

        // Text
        if (options.text) {
            var text = document.createElement(/<p[\s>]/i.test(options.text) ? 'div' : 'p');
            text.className = 'modal__text';
            text.innerHTML = options.text;
            body.appendChild(text);
        }

        // Value (opcjonalne)
        if (options.value) {
            var value = document.createElement('p');
            value.className = 'modal__value';
            value.textContent = options.value;
            body.appendChild(value);
        }

        // Text extra — opcjonalny dodatkowy tekst pod value
        if (options.textExtra) {
            var textExtra = document.createElement('p');
            textExtra.className = 'modal__text-extra';
            textExtra.innerHTML = options.textExtra;
            body.appendChild(textExtra);
        }

        // Challenge — postęp dynamicznego wyzwania
        if (options.challenge) {
            body.appendChild(createChallengeElement(options.challenge));
        }

        // Actions
        var actions = document.createElement('div');
        actions.className = 'modal__actions';

        // Confirm button (obowiązkowy) — btn btn-primary
        var confirmBtn = document.createElement('button');
        confirmBtn.className = 'btn btn-primary';
        confirmBtn.textContent = options.confirmLabel || 'OK';
        confirmBtn.addEventListener('click', function () {
            if (typeof options.onConfirm === 'function') {
                options.onConfirm();
            }
            hide();
        });
        actions.appendChild(confirmBtn);

        // Cancel button (opcjonalny) — btn btn-secondary-positive
        if (options.cancelLabel) {
            var cancelBtn = document.createElement('button');
            cancelBtn.className = 'btn btn-secondary-positive';
            cancelBtn.textContent = options.cancelLabel;
            cancelBtn.addEventListener('click', function () {
                if (typeof options.onCancel === 'function') {
                    options.onCancel();
                }
                hide();
            });

            // Na desktop: Anuluj jest PRZED Odbierz (w Figma kolejność: Anuluj | Odbierz)
            actions.insertBefore(cancelBtn, confirmBtn);
        }

        body.appendChild(actions);
        dialog.appendChild(body);
        backdrop.appendChild(dialog);

        // Klik na backdrop zamyka modal
        backdrop.addEventListener('click', function (e) {
            if (e.target === backdrop) {
                hide();
            }
        });

        return backdrop;
    }

    /**
     * Slot postępu dynamicznego wyzwania (tytuł, licznik, mini-pasek, komunikat)
     */
    function createChallengeElement(challenge) {
        var hasBar = typeof challenge.current === 'number' && typeof challenge.total === 'number' && challenge.total > 0;
        var isDone = hasBar && challenge.current >= challenge.total;

        var wrapper = document.createElement('div');
        wrapper.className = 'modal__challenge' +
            (hasBar ? '' : ' modal__challenge--simple') +
            (isDone ? ' modal__challenge--success' : '');

        if (challenge.title) {
            var title = document.createElement('p');
            title.className = 'modal__challenge-title';
            title.textContent = challenge.title;
            wrapper.appendChild(title);
        }

        if (hasBar) {
            var current = Math.min(challenge.current, challenge.total);

            var counter = document.createElement('p');
            counter.className = 'modal__challenge-counter';
            counter.textContent = current + ' / ' + challenge.total + ' ' + (challenge.counterLabel || 'dodanych kodów');
            wrapper.appendChild(counter);

            var track = document.createElement('div');
            track.className = 'modal__challenge-track';
            track.setAttribute('role', 'progressbar');
            track.setAttribute('aria-valuemin', '0');
            track.setAttribute('aria-valuemax', String(challenge.total));
            track.setAttribute('aria-valuenow', String(current));

            var fill = document.createElement('span');
            fill.className = 'modal__challenge-fill';
            fill.style.width = (current / challenge.total * 100) + '%';
            track.appendChild(fill);
            wrapper.appendChild(track);
        }

        if (challenge.message) {
            var message = document.createElement('p');
            message.className = 'modal__challenge-message';
            message.innerHTML = challenge.message;
            wrapper.appendChild(message);
        }

        return wrapper;
    }

    /**
     * Obsługa klawisza Escape
     */
    function handleKeydown(e) {
        if (e.key === 'Escape' && currentBackdrop) {
            hide();
        }
    }

    /**
     * Pokaż modal
     */
    function show(options) {
        if (!options) return;

        // Singleton — zamknij poprzedni natychmiast
        if (currentBackdrop) {
            removeModal(currentBackdrop);
        }

        var backdrop = createModalElement(options);
        document.body.appendChild(backdrop);
        currentBackdrop = backdrop;

        // Scroll lock
        document.body.classList.add('modal-open');

        // Nasłuchuj Escape
        document.addEventListener('keydown', handleKeydown);

        // Trigger reflow before adding class (force animation)
        void backdrop.offsetHeight;

        backdrop.classList.add('is-active');

        // Focus na dialog (accessibility)
        var dialog = backdrop.querySelector('.modal');
        if (dialog) {
            dialog.setAttribute('tabindex', '-1');
            dialog.focus();
        }
    }

    /**
     * Ukryj modal z animacją
     */
    function hide() {
        if (!currentBackdrop) return;

        var backdrop = currentBackdrop;

        backdrop.classList.remove('is-active');
        backdrop.classList.add('is-dismissing');

        // Czekaj na koniec animacji
        var dialog = backdrop.querySelector('.modal');
        if (dialog) {
            dialog.addEventListener('transitionend', function handler() {
                dialog.removeEventListener('transitionend', handler);
                removeModal(backdrop);
            });
        } else {
            removeModal(backdrop);
        }

        // Fallback — usuń po max transition time
        setTimeout(function () {
            removeModal(backdrop);
        }, 400);
    }

    /**
     * Usuń modal z DOM
     */
    function removeModal(backdrop) {
        if (backdrop && backdrop.parentNode) {
            backdrop.parentNode.removeChild(backdrop);
        }
        if (currentBackdrop === backdrop) {
            currentBackdrop = null;
        }

        // Scroll unlock
        document.body.classList.remove('modal-open');

        // Usuń listener Escape
        document.removeEventListener('keydown', handleKeydown);
    }

    // Globalne API
    window.Modal = {
        show: show,
        hide: hide
    };
})();
